import { ActiveUserProducer } from 'types/types.type';
import { Organization } from 'types/organization.type';
import React, { ReactFragment } from 'react';
import { BaseActiveProducer } from './BaseActiveProducer';

// This is for lumen users who should not be producers so everything is empty
export class LumenActiveUserProducer extends BaseActiveProducer {
    getAvailableProducers(): Organization[] {
        return [];
    }
    getCreateSubmissionSubHeader(assignedProducer: Organization, doSelectProducer: () => void): ReactFragment {
        return '';
    }
    getEffectiveActiveProducer(): Organization | undefined {
        return undefined;
    }
    async fetchAvailableAgents(): Promise<void> {
        return new Promise<void>((res) => {
            res();
        });
    }

    getProducer(): Organization {
        return {} as Organization;
    }

    getId(): string | undefined {
        return undefined;
    }

    validateAssignedProducer(assignedProducer: Organization): Organization | undefined {
        return undefined;
    }

    getTemplateQualifier(fileType: string, availableQualifiers: string[] | undefined): string {
        return '';
    }
}
